import { Component, ElementRef, OnInit, EventEmitter, Output, ViewChild } from '@angular/core';
import { NegocioQualificacaoSearch } from '../../qualificacao/negocio-qualificacao-search';
import { NegocioOportunidadeSearch } from '../../oportunidade/negocio-oportunidade-search';
import { NegocioFormInsertWizardComponent } from '../wizard';
import { FunilVendaFaseTipo } from '../../../funil-venda/fase';

@Component({
    selector: 'sgt-negocio-form-insert-modal',
    templateUrl: './negocio-form-insert-modal.component.html',
    styleUrls: ['./negocio-form-insert-modal.component.less']
})
export class NegocioFormInsertModalComponent implements OnInit {
    elModal: any;
    isInserting: boolean;

    @Output() afterCreateQualificacao = new EventEmitter<NegocioQualificacaoSearch>();
    @Output() afterCreateOportunidade = new EventEmitter<NegocioOportunidadeSearch>();
    @Output() onClose = new EventEmitter<NegocioQualificacaoSearch>();

    @ViewChild('formWizard') formWizard: NegocioFormInsertWizardComponent;

    constructor(private el: ElementRef) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                this.isInserting = false;
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    /** Abre o modal para inserir um novo negócio */
    insert(idFunilVenda: number, tipoFunilVendaFase: FunilVendaFaseTipo, idLead: number = null, idCliente: number = null) {
        this.isInserting = true;
        setTimeout(() => {
            this.formWizard.insert(idFunilVenda, tipoFunilVendaFase, idLead, idCliente);
            this.elModal.modal({keyboard: false, backdrop: 'static'});
        }, 0);
    }

    /** Fecha o modal */
    close() {
        this.elModal.modal('hide');
    }

    /** Após criar um novo negócio a ser qualificado */
    onAfterCreateQualificacao(qualificacao: NegocioQualificacaoSearch) {
        this.afterCreateQualificacao.emit(qualificacao);
        this.close();
    }

    /** Após criar uma nova oportunidade de negócio */
    onAfterCreateOportunidade(oportunidade: NegocioOportunidadeSearch) {
        this.afterCreateOportunidade.emit(oportunidade);
        this.close();
    }
}
